function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Global } from '@emotion/react';
import { useTheme } from '@veneer/theme';
import resetStyles from './reset_styles';
import typographyStyles from './typography_styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var html = {
  boxSizing: 'border-box',
  textRendering: 'optimizeLegibility',
  MozOsxFontSmoothing: 'grayscale',
  // Anti-aliasing.
  WebkitFontSmoothing: 'antialiased',
  // Anti-aliasing.
  WebkitTextSizeAdjust: '100%'
};
var styles = theme => _objectSpread(_objectSpread({}, resetStyles()), {}, {
  html,
  '*, *::before, *::after': {
    boxSizing: 'border-box',
    scrollBehavior: 'smooth'
  },
  body: {
    backgroundColor: theme.color.background.default,
    color: theme.color.foreground.default,
    margin: 0
  },
  'i, em, .italic': {
    fontStyle: 'italic'
  },
  'strong, b, .bold': {
    fontFamily: theme.typography.family0
  },
  '*:focus-visible': {
    outline: "2px solid ".concat(theme.color.focus.default)
  },
  'a, .link': {
    color: theme.color.primary.base.default,
    textDecoration: 'underline',
    ':hover': {
      color: theme.color.primary.base.hover,
      textDecoration: 'underline'
    },
    ':active': {
      color: theme.color.primary.base.active,
      textDecoration: 'underline'
    },
    ':focus-visible': {
      boxShadow: "0px 0px 0px  2px ".concat(theme.color.focus.inverse),
      outline: "2px solid ".concat(theme.color.focus.default)
    }
  }
}, typographyStyles(theme));
var CssBaseline = () => {
  var theme = useTheme();
  return ___EmotionJSX(Global, {
    styles: styles(theme)
  });
};
CssBaseline.displayName = 'CssBaseline';
export default CssBaseline;